module.exports = __webpack_public_path__ + "static/img/lifestyle_21.d5694870.jpg";